import React, { useEffect, useRef, useState } from "react";
import Highcharts from "highcharts";
import { strikeZoneChartWithRedBox } from "../../shared/function";
import PropTypes from "prop-types";
import BallrWebGL from "../../view/webGL/BallrWebGL";
import PitchRWebGL from "../../view/webGL/PitchRWebGL";
import Toggle from "../../shared/Toggle";
import domtoimage from 'dom-to-image';
import PrintImagePopup from "../../shared/PrintImagePopup";
import { downloadChartPrintImg } from "../../shared/printReportUtils";
import html2canvas from "html2canvas";
import use3DView from "../../shared/use3DView";
function StrikeZoneChart({ chartData, id, showTitle, ballrIframeFlag, closeBallrIframe, cameraAngle, visualType, pitchrIframeFlag, closePitchrIframe, developmentTab, eventName, pitcherDefault, profilepage, isNotDownloadImgLoader, isDownloadImgLoader }) {
  const [data3D, setData3D, toggle, setToggle, onClickToggleButton, flag] = use3DView(id);
  const [isChartImg, setIsChartImg] = useState(false);
  const [clickFlag, setClickFlag] = useState(false);
  const [ballrFlag, setBallrFlag] = useState(false);
  const [tooltipData, setTooltipData] = useState(null);
  const [state, setState] = useState({
    chart: {
      type: "scatter",
      borderWidth: 0,
      marginTop: 135,
      borderColor: "#D8D8D8",
      borderRadius: "8px",
    },
    title: {
      text: "",
    },
    xAxis: {
      title: {
        enabled: true,
        // text: "Side at Plate (ft)",
        text: "",
        style: {
          color: "#777F8F",
          fontFamily: "Poppins, sans-serif",
          fontSize: "14px",
          fontWeight: "500",
        },
      },
      min: -2.5,
      max: 2.5,
      tickInterval: 1
    },
    yAxis: {
      title: {
        enabled: true,
        // text: "Height at Plate (ft)",
        text: "",
        style: {
          color: "#777F8F",
          fontFamily: "Poppins, sans-serif",
          fontSize: "14px",
          fontWeight: "500",
        },
      },
      min: 0,
      max: 5,
    },
    legend: {
      layout: "horizontal",
      align: "center",
      verticalAlign: "top",
      y: 35,
    },
    credits: { enabled: false },
    plotOptions: {
      series: {
        stickyTracking: false,
        states: {
          inactive: {
            opacity: 1
          }
        }
      }
    },
    tooltip: {
      useHTML: true,
      hideDelay: 500,
      formatter: function () {
        setTooltipData(this?.point);
        // ballrFlag && refview.current.GiveKeyToiframe(this?.point);
        setBallrFlag(true)
        if (this.point.series.name === "Strikezone") return false;
        if (this.point.series.name === "Stadium") return false;
        let tooltip = `<span style="color: ${this.point.color
          }; font-weight:bold;">${this.point.options.pitch_type}</span><br>
          <span style="font-weight:bold;">Pitch No: ${this.point.options.pitch_number
            ? this.point.options.pitch_number
            : "-"
          }</span><br>
          <span style="font-weight:bold;">Pitcher: ${this.point.options.pitcher ? this.point.options.pitcher : "-"
          }</span><br>
          <span style="font-weight:bold;">Batter: ${this.point.options.batter ? this.point.options.batter : "-"
          }</span><br>
          <span style="font-weight:bold;">Play Result: ${this.point.options.pitch_call ? this.point.options.pitch_call : "-"
          }</span><br>
          <span style="font-weight:bold;">Velocity: ${this.point.options && this.point.options.velocity
            ? this.point.options.velocity.toFixed(1)
            : "-"
          }</span><br>
          <span style="font-weight:bold;">Spin Rate: ${this.point.options && this.point.options.spin_rate
            ? Math.round(this.point.options.spin_rate)
            : "-"
          }</span><br>
          <span style="font-weight:bold;">Tilt: ${this.point.options && this.point.options.tilt
            ? this.point.options.tilt
            : "-"
          }</span><br>
          <span style="font-weight:bold;">Axis: ${this.point.options && this.point.options.spin_axis
            ? Math.round(this.point.options.spin_axis)
            : "-"
          }</span><br>
          <span style="font-weight:bold;">Efficiency: ${this.point.options && this.point.options.efficiency
            ? Math.round(this.point.options.efficiency)
            : "-"
          }</span><br>
          <span style="font-weight:bold;">Vert Break: ${this.point.options && this.point.options.v_break
            ? this.point.options.v_break.toFixed(1)
            : "-"
          }</span><br>
          <span style="font-weight:bold;">Ind V Break: ${this.point.options && this.point.options.ind_v_break
            ? this.point.options.ind_v_break.toFixed(1)
            : "-"
          }</span><br>
          <span style="font-weight:bold;">H Break: ${this.point.options && this.point.options.h_break
            ? this.point.options.h_break.toFixed(1)
            : "-"
          }</span><br>
          <span style="font-weight:bold;">V Approach: ${this.point.options && this.point.options.vert_appr_angle
            ? this.point.options.vert_appr_angle.toFixed(1)
            : "-"
          }</span><br>
          <span style="font-weight:bold;">Rel Height: ${this.point.options && this.point.options.release_height
            ? this.point.options.release_height.toFixed(1)
            : "-"
          }</span><br>
          <span style="font-weight:bold;">Rel Side: ${this.point.options && this.point.options.release_side
            ? this.point.options.release_side.toFixed(1)
            : "-"
          }</span><br>
          <span style="font-weight:bold;">Extension: ${this.point.options && this.point.options.extension
            ? this.point.options.extension.toFixed(1)
            : "-"
          }</span><br>
          <span style="font-weight:bold;">Exit Velocity: ${this.point.options && this.point.options.exit_velocity
            ? this.point.options.exit_velocity.toFixed(1)
            : "-"
          }</span><br>
          <span style="font-weight:bold;">Launch Angle: ${this.point.options && this.point.options.launch_angle
            ? this.point.options.launch_angle.toFixed(1)
            : "-"
          }</span><br>
          <span style="font-weight:bold;">Distance: ${this.point.options && this.point.options.distance
            ? Math.round(this.point.options.distance)
            : "-"
          }</span><br>
        <span style="font-weight:bold;">yt_seam_lat: ${this.point.options && this.point.options.yt_seam_lat
            ? this.point.options.yt_seam_lat.toFixed(1)
            : "-"
          }</span><br>
        <span style="font-weight:bold;">yt_seam_long: ${this.point.options && this.point.options.yt_seam_long
            ? this.point.options.yt_seam_long.toFixed(1)
            : "-"
          }</span>
          <!-- <div style="color: red" onmouseover="StrikeLoadBallR()">BallR</div> -->
          </span>`;
        return tooltip;
      },
      // if hover or click functionality add in tooltip use pointerEvents
      style: {
        pointerEvents: 'auto'
      }
    },
    series: [],
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 500,
          },
        },
      ],
    },
  });

  useEffect(() => {
    if (toggle.chartToggle === true) {
      if (chartData) {
        // developmentTab !== true && increment();
        if (showTitle) {
          // state.title = {
          //   text: "Strike Zone",
          //   layout: "horizontal",
          //   align: "left",
          //   verticalAlign: "left",
          //   y: 20,
          //   x: 10,
          //   style: {
          //     color: "#1B1B1B",
          //     fontFamily: "Poppins, sans-serif",
          //     fontSize: "18px",
          //     fontWeight: "bold",
          //   },
          // }
        }
        if (chartData.length !== 0) {
          const seriesData = strikeZoneChartWithRedBox(chartData);
          state.series = seriesData;
          if (state.series) {
            state.series[state.series.length - 1].showInLegend = false
            // state.series.filter(x => x.name === "").map((item) => {
            //   Object.assign(item, { showInLegend: false })
            // })
          }
          Highcharts.chart(id, state);
          // developmentTab !== true && decrement();
        } else {
          state.series = [{ showInLegend: false }];
          Highcharts.chart(id, state);
          // developmentTab !== true && decrement();
        }
      }
    } else {
      if (chartData && chartData.length !== 0) {
        let arr = chartData.map(x => x?._id) || []
        setData3D(arr)
      }
    }
  }, [chartData, toggle]);

  // bullpen event player name change,set ballriframe initial state 
  useEffect(() => {
    if (ballrIframeFlag === "yes") {
      setBallrFlag(false)
      setTooltipData(null);
      closeBallrIframe();
    }
  }, [ballrIframeFlag])

  // bullpen event player name change,set pichRIframe initial state
  useEffect(() => {
    if (pitchrIframeFlag === "yes") {
      setData3D(null)
      setToggle({ chartToggle: true });
      closePitchrIframe();
    }
  }, [pitchrIframeFlag])

  const chartImage = (id) => {
    isDownloadImgLoader();
    setClickFlag(true)
    if (document.getElementById(`img${id}`)) {
      document.getElementById(`img${id}`).remove()
    }
    setIsChartImg(true)
    downloadChartPrintImg(id, setIsChartImg, setClickFlag, isNotDownloadImgLoader)
  }

  return (
    <>
      <div className={`ground-chart ${ballrFlag ? "chart-ifream" : ""}`}>
        {chartData && chartData.length !== 0 ? developmentTab !== true && <Toggle toggle={toggle} onClickToggleButton={onClickToggleButton} /> : ""}
        <div style={{ display: toggle.chartToggle === true ? 'block' : 'none' }}>
          <div className="ifream-box">
            {ballrFlag && <BallrWebGL tooltipData={tooltipData} id={id} index={tooltipData?._id} />}
          </div>
          <div style={{ height: "470px" }} id={id} />
          {developmentTab !== true && <div class="chartdownload" onClick={() => chartImage(id)} disabled={clickFlag}><a class="btn white"><i class="fa fa-download" aria-hidden="true"></i></a></div>}
        </div>
        {flag?.[`iframe_${id}`] === true && developmentTab !== true && <div id="pitchR-iframe" className="Chart-iframe" style={{ display: toggle.chartToggle === false ? 'block' : 'none' }}>
          <PitchRWebGL data={data3D} id={id} cameraAngle={cameraAngle} visualType={visualType} Toggle={toggle.chartToggle} />
        </div>}
      </div>

      {/* chart visual image download */}
      {isChartImg && <PrintImagePopup
        id={id}
        eventName={eventName}
        pitcherDefault={pitcherDefault}
        profilepage={profilepage} />}
    </>
  );
}

StrikeZoneChart.propTypes = {};

export default StrikeZoneChart;
